var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.05 10C18.05 14.446 14.4459 18.05 10 18.05C5.55411 18.05 1.94998 14.4459 1.94998 10C1.94998 5.55411 5.55411 1.94998 10 1.94998C14.446 1.94998 18.05 5.55411 18.05 10ZM10 19.05C14.9981 19.05 19.05 14.9981 19.05 10C19.05 5.00179 14.9981 0.95 10 0.95C5.00179 0.95 0.95 5.00179 0.95 10C0.95 14.9981 5.00179 19.05 10 19.05Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3119 6.17465C7.86002 5.87337 7.25469 6.19731 7.25469 6.74042V13.2678C7.25469 13.8109 7.86001 14.1349 8.3119 13.8336L13.2074 10.5699C13.6112 10.3007 13.6112 9.70747 13.2074 9.43827L8.3119 6.17465ZM8.3119 6.17465L8.28418 6.21622L8.3119 6.17465L8.3119 6.17465ZM8.25477 12.6698V7.33835L12.2534 10.004L8.25477 12.6698Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.b18fd62cbd753b4fb071cd81b98e6dcb.svg";
export { ForwardRef as ReactComponent };